"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const CommonMarkerStyle = (0, styled_components_1.css) `
  .Marker {
    position: relative;
    z-index: 103;

    display: flex;
    justify-content: center;
    align-items: flex-end;

    width: 0;
    height: 0;

    > * {
      box-sizing: border-box;
    }

    /* 
      .noMouse {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        
        width:0;
        height:0;
        
        
      }  */

    //padding-right: 14px;

    .Marker__Bar {
      position: absolute;
      //left: 1px;
      z-index: 104;

      width: 2px;
      height: 22px;
      border-radius: 0.7px;

      background-color: #0e3d90;
    }

    .Marker__Point {
      position: absolute;
      top: calc(-24px - 15px);
      left: calc(-24px / 2);
      z-index: 105;

      display: flex;
      justify-content: center;
      align-items: center;

      min-width: 24px;
      height: 24px;
      max-height: 24px;

      border-radius: 50px;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
      background-color: #245fc6;

      font-size: 0.8125rem;
      font-weight: bold;
      line-height: 1.1875rem;
      text-align: center;
      vertical-align: middle;
      color: #fff;
    }
    .Marker__Point__100 {
      box-sizing: border-box;

      position: absolute;
      top: calc(-24px - 15px);
      left: calc((-24px / 2) - 3px);
      z-index: 105;

      display: flex;
      justify-content: center;
      align-items: center;

      min-width: 24px;
      max-height: 24px;

      padding: 2px 3.5px 1px;

      border-radius: 50px;

      background-color: #245fc6;

      font-size: 0.8125rem;
      font-weight: bold;
      color: #fff;

      line-height: 1.1875rem;
    }

    .Marker__Number {
      position: absolute;
      top: 50%;
      left: 50%;

      display: flex;
      justify-content: center;
      align-items: center;

      width: 0;
      height: 0;

      color: #fff;
    }

    .Marker__Number__100 {
      color: #fff;
    }

    .Marker__Center {
      width: 6px;
      height: 6px;

      border-radius: 50px;

      background-color: #fff;
    }

    .Marker__Container {
      position: absolute;
      z-index: 103;
      top: calc(-40px - 7px);
      left: calc(-12px - 9px);

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      min-width: 54px;
      min-height: 40px;
      max-height: 40px;
      white-space: nowrap;

      padding: 3.8px 14px 2px 38px;
      border: solid 1px #245fc6;
      border-radius: 30px;

      background-color: #fff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.3);
    }

    /* .onMouse {
        .Marker__Container {
          border: solid 1px #ff5d4b;
        }
        .Marker__Point {
          background: #ff5d4b;
        }
        .Marker__Bar {
          background: #dc4231;
        }
      }
       */
    .Marker__Title {
      position: relative;
      top: 1.5px;

      min-height: 17px;
      max-height: 17px;
      text-shadow: 0 1px 2px #fff;

      letter-spacing: -0.0375rem;
      font-size: 0.75rem;
      font-weight: bold;
      text-align: start;
      line-height: 1.0625rem;
      color: #222;
    }

    .Marker__Category {
      position: relative;
      top: -1.5px;

      min-height: 15px;
      max-height: 15px;
      text-shadow: 0 1px 2px #fff;

      font-size: 0.625rem;
      font-weight: 500;
      text-align: start;
      letter-spacing: -0.0313rem;
      line-height: 0.9375rem;
      color: #8e8e8e;
    }

    /* img {
        width: 36px;
        height: 46px;
      }
      img.onMouse {
        display: none;
      }
      span {
        position: absolute;
        top: 8px;
        left: 50%;
        transform: translate(-50%, 0%);
        font-size: 11px;
        color: #fff;
        font-weight: 500;
      } */
  }

  .ShowMark {
    z-index: 200;
    .Marker__Container {
      border: solid 1px #ff5d4b;
    }
    .Marker__Point {
      background-color: #ff5d4b;
    }
    .Marker__Point__100 {
      background-color: #ff5d4b;
    }
    .Marker__Bar {
      background-color: #dc4231;
    }
  }
`;
exports.default = CommonMarkerStyle;
